export var ESummaryStatus;
(function (ESummaryStatus) {
    ESummaryStatus["Ready"] = "ready";
    ESummaryStatus["Replaying"] = "replaying";
    ESummaryStatus["Failed"] = "failed";
})(ESummaryStatus || (ESummaryStatus = {}));
//# sourceMappingURL=summary.enum.js.map